/* eslint-disable @typescript-eslint/no-namespace */

export namespace TestId {
  export namespace UserDashboardHeader {
    export const Dashboard = 'user-dashboard-header-dashboard';
    export const FirstName = 'user-dashboard-header-first-name';
    export const OrganizationName = 'user-dashboard-header-organization-name';
    export const CollapseButton = 'collapse-button';
    export const Team = 'user-dashboard-header-team';
    export const Today = 'user-dashboard-header-today';
  }
  export namespace SignLinkDialog {
    export const SignButton = 'sign-link-dialog-sign-button';
  }
  export namespace Widget {
    export namespace Code {
      export const CodeView = 'widget-code-view';
    }
  }
  export namespace FormWriter {
    export namespace Radio {
      export const RadioGroup = 'form-writer-radio-group';
      export const RadioItem = 'form-writer-radio-item';
    }
    export namespace DateEntry {
      export const CalendarButton = 'date-entry-calendar-button';
      export const Calendar = 'date-entry-calendar';
      export const DateInput = 'date-entry-date-input';
      export const TodayButton = 'date-entry-today-button';
    }
    export const TextInput = 'text-input';
    export const TextArea = 'text-area';

    export namespace Checkbox {
      export const Checkbox = 'checkbox-simple';
      export const CheckboxLabel = 'checkbox-label';
    }
    export namespace Checkboxes {
      export const Checkboxes = 'checkboxes';
      export const CheckboxesLabel = 'checkboxes-label';
      export const CheckBoxesAll = 'checkboxes-all';
    }
  }
  export namespace Login {
    export const Button = 'login-button';
  }
  export namespace UnexpectedErrorBoundary {
    export const SendEmailButton = 'send-email-button';
  }
  export namespace ErrorPage {
    export const ReloadButton = 'reload-button';
    export const RedirectButton = 'redirect-button';
    export const ErrorMessage = 'error-message';
  }
  export namespace Copy {
    export const Button = 'copy-button';
  }
  export namespace WorkflowGroups {
    export const GoBackButton = 'go-back-button';
    export namespace SubHeader {
      export const AddGroupButton = 'add-group-button';
      export const SearchInput = 'groups-filter-input';
    }
    export namespace GroupsList {
      export const LoadMoreButton = 'load-more-button';
    }
    export namespace AddGroupModal {
      export const CancelButton = 'add-group-modal-cancel-button';
      export const SubmitButton = 'add-group-modal-submit-button';
      export const GroupNameInput = 'add-group-modal-group-name-input';
    }
  }
  export namespace GroupSettings {
    export const GoBackButton = 'go-back-button';
  }
  export namespace UploadAvatar {
    export const Button = 'upload-avatar-button';
    export const Input = 'upload-avatar-input';
  }
  export namespace CropImage {
    export const CancelButton = 'crop-cancel-button';
    export const SubmitButton = 'crop-submit-button';
  }
  export namespace AddUsers {
    export const CancelButton = 'add-users-cancel-button';
    export const SubmitButton = 'add-users-submit-button';
  }
  export namespace AddTeams {
    export const CancelButton = 'add-teams-cancel-button';
    export const SubmitButton = 'add-teams-submit-button';
  }
  export namespace AddParticipantsModal {
    export const UsersTab = 'add-participants-modal-users-tab';
    export const TeamsTab = 'add-participants-modal-teams-tab';
  }
  export namespace EditableGroupFields {
    export const GroupNameInput = 'group-name-input';
    export const UpdateGroupNameButton = 'update-group-name-button';
    export const UploadAvatar = 'upload-avatar';
  }
  export namespace TeamItem {
    export const ToggleTeamName = 'toggle-team-name';
    export const ToggleTeamCheckbox = 'toggle-team-checkbox';
  }
  export namespace MultipleValuesTextArea {
    export const TextInput = 'text-input';
  }
  export namespace ValueLabel {
    export const RemoveButton = 'value-label-remove-button';
  }
  export namespace SubHeaderGroupSettings {
    export const AddParticipantsButton = 'add-participants-button';
  }
  export namespace ParticipantsList {
    export const ListToggle = 'list-toggle';
    export const RemoveAllButton = 'remove-all-button';
  }
  export namespace RemoveGroupMembersModal {
    export const CancelButton = 'remove-group-members-modal-cancel-button';
    export const SubmitButton = 'remove-group-members-modal-submit-button';
  }
  export namespace ParticipantCard {
    export const RemoveButton = 'participant-card-remove-button';
  }
}
